import React from 'react';
import TopBar from '../../components/TopBar';
import Header from '../../components/headerfooter/Header';
import Footer from '../../components/headerfooter/Footer';
import CallToAction from '../../components/home/CallToAction';
import PageBanner from '../../components/PageBanner';
import {Link} from 'react-router-dom';
import { FaStar, FaRegStar } from "react-icons/fa";
import { MdBookmark } from "react-icons/md";
import { AiOutlineLink } from "react-icons/ai";

const AllImageCategories = () => {
  const tools = [
    {
      name: "Brandblast.ai",
      logo: "https://cdn2.futurepedia.io/1018ee2fe376d7dd598ca2576d7fc6ebb2c1f797-128x128.png",
      link: "#",
      rating: 4,  // Rating out of 5
    },
    {
        name: "Brandblast.ai",
        logo: "https://cdn2.futurepedia.io/1018ee2fe376d7dd598ca2576d7fc6ebb2c1f797-128x128.png",
        link: "#",
        rating: 4,  // Rating out of 5
      },
      {
        name: "Brandblast.ai",
        logo: "https://cdn2.futurepedia.io/1018ee2fe376d7dd598ca2576d7fc6ebb2c1f797-128x128.png",
        link: "#",
        rating: 4,  // Rating out of 5
      },
  ];
  return (
    <>
      <TopBar />
      <Header />
      <PageBanner title="AI Image Tools" para="Crafting Compelling Visual Representations from Ideas" />
        <div className="bg-background-back1 py-10">
        <div className="container mx-auto px-4 max-w-[80rem]">
        <div
        className="flex flex-col md:flex-row items-center  py-8 md:space-x-8"
        id="all-cate"
      >
        {/* Left Column: Title */}
        <div className="flex-1 flex flex-col items-center justify-center md:items-start mb-6 md:mb-0">
        <h2 className="text-[26px] md:text-[34px] text-center text-black leading-tight flex items-center" >
              <span className="font-bold text-[35px] md:text-[40px] bg-[linear-gradient(45deg,_#00bf67,_#0068ff)] bg-clip-text text-transparent mr-2">
                Design Generators
              </span>
              
            </h2>
        </div>

        {/* Right Column: Button */}
        <div className="flex-1 flex justify-center md:justify-end">
          <Link
            to="/ai-tools/design-generators"
            className="px-6 py-3 border-2 border-customBlue text-white font-semibold rounded shadow hover:bg-background-primary transition duration-200"
          >
            View More
          </Link>
        </div>
      </div>
      <div className="mx-auto grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3">
      {tools.map((tool, index) => (
          <div
            key={index}
            className="flex flex-col border-2 border-customGray hover:border-customBlue bg-background-back2 text-card-foreground h-full w-full rounded-xl"
          >
            <div className="px-6 pb-2 pt-4 flex h-24 items-start gap-4">
              <Link to={tool.link}>
                <div className="relative flex h-[60px] w-[60px] flex-shrink-0 rounded-xl border">
                  <img
                    alt={`${tool.name} logo`}
                    src={tool.logo}
                    className="aspect-square h-[60px] w-[60px] rounded-xl"
                  />
                </div>
              </Link>
              <div>
              <div>
                <h2 className="text-lg font-bold text-white">{tool.name}</h2>
                </div>
                {/* Rating stars */}
                    <div className=" flex items-center gap-1 text-yellow-500">
                    {Array.from({ length: 5 }, (_, i) => (
                        i < tool.rating ? (
                        <FaStar key={i} className="h-4 w-4 text-yellow-500" />
                        ) : (
                        <FaRegStar key={i} className="h-4 w-4 text-gray-300" />
                        )
                    ))}
                    <span className="text-gray-300 ml-2">({tool.rating})</span>
                </div>
              </div>
            </div>
            <div className="px-6">
              <div className="flex justify-between text-lg text-white">
                <span>Paid</span>
                  <Link to="" >
                  <span className="flex items-center text-slate-500">
                    <span className="mr-1">10</span>
                    <MdBookmark className="text-gray-300 hover:text-primary pointer h-5 w-5" />
                    <span className="sr-only">Add bookmark</span>
                  </span>
                  </Link>
              </div>
            </div>
            <p className="text-gray-300 my-2 line-clamp-2 overflow-hidden overflow-ellipsis px-6 text-base">
              Automate, schedule, and optimize brand-specific social content.
            </p>
            <div className="px-6 mb-6 flex flex-wrap gap-1 py-2 text-base text-ice-500">
              <div className="flex flex-wrap gap-x-2 gap-y-1 text-primary">
                <Link className="hover:text-underline" to="#">
                  #marketing
                </Link>
                <Link className="hover:text-underline" to="#">
                  #social media
                </Link>
                <Link className="hover:text-underline" to="#">
                  #copywriting
                </Link>
              </div>
            </div>

            <div className="px-6 mt-auto flex items-center justify-between pb-4">
              <div className="tool-label flex items-center gap-2 text-[#6b7280] ">
                <FaStar className="h-5 w-5 text-yellow-500" />
                <span className="mt-[4px]">Featured</span>
              </div>
              <Link
                rel="nofollow"
                target="_blank"
                className="hover:no-underline"
                to="#"
              >
                <button className=" border-2 border-customBlue flex text-white px-4 py-2 rounded hover:bg-background-primary transition text-[15px] font-bold uppercase">
                  <span className="mr-2">Visit</span>
                  <AiOutlineLink className="h-5 w-5" />
                </button>
              </Link>
            </div>
          </div>
        ))}
        </div>

        <div
        className="flex flex-col md:flex-row items-center  py-8 md:space-x-8 mt-16 pt-16 border-t-[1px] border-[#272727]"
        id="all-cate"
      >
        {/* Left Column: Title */}
        <div className="flex-1 flex flex-col items-center justify-center md:items-start mb-6 md:mb-0">
        <h2 className="text-[26px] md:text-[34px] text-center text-black leading-tight flex items-center" >
              <span className="font-bold text-[35px] md:text-[40px] bg-[linear-gradient(45deg,_#00bf67,_#0068ff)] bg-clip-text text-transparent mr-2">
              Image Generators
              </span>
              
            </h2>
        </div>

        {/* Right Column: Button */}
        <div className="flex-1 flex justify-center md:justify-end">
          <Link
            to="#"
            className="px-6 py-3 border-2 border-customBlue text-white font-semibold rounded shadow hover:bg-background-primary transition duration-200"
          >
            View More
          </Link>
        </div>
      </div>
      <div className="mx-auto grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3">
      {tools.map((tool, index) => (
          <div
            key={index}
            className="flex flex-col border-2 border-customGray hover:border-customBlue bg-background-back2 text-card-foreground h-full w-full rounded-xl"
          >
            <div className="px-6 pb-2 pt-4 flex h-24 items-start gap-4">
              <Link to={tool.link}>
                <div className="relative flex h-[60px] w-[60px] flex-shrink-0 rounded-xl border">
                  <img
                    alt={`${tool.name} logo`}
                    src={tool.logo}
                    className="aspect-square h-[60px] w-[60px] rounded-xl"
                  />
                </div>
              </Link>
              <div>
              <div>
                <h2 className="text-lg font-bold text-white">{tool.name}</h2>
                </div>
                {/* Rating stars */}
                    <div className=" flex items-center gap-1 text-yellow-500">
                    {Array.from({ length: 5 }, (_, i) => (
                        i < tool.rating ? (
                        <FaStar key={i} className="h-4 w-4 text-yellow-500" />
                        ) : (
                        <FaRegStar key={i} className="h-4 w-4 text-gray-300" />
                        )
                    ))}
                    <span className="text-gray-300 ml-2">({tool.rating})</span>
                </div>
              </div>
            </div>
            <div className="px-6">
              <div className="flex justify-between text-lg text-white">
                <span>Paid</span>
                  <Link to="" >
                  <span className="flex items-center text-slate-500">
                    <span className="mr-1">10</span>
                    <MdBookmark className="text-gray-300 hover:text-primary pointer h-5 w-5" />
                    <span className="sr-only">Add bookmark</span>
                  </span>
                  </Link>
              </div>
            </div>
            <p className="text-gray-300 my-2 line-clamp-2 overflow-hidden overflow-ellipsis px-6 text-base">
              Automate, schedule, and optimize brand-specific social content.
            </p>
            <div className="px-6 mb-6 flex flex-wrap gap-1 py-2 text-base text-ice-500">
              <div className="flex flex-wrap gap-x-2 gap-y-1 text-primary">
                <Link className="hover:text-underline" to="#">
                  #marketing
                </Link>
                <Link className="hover:text-underline" to="#">
                  #social media
                </Link>
                <Link className="hover:text-underline" to="#">
                  #copywriting
                </Link>
              </div>
            </div>

            <div className="px-6 mt-auto flex items-center justify-between pb-4">
              <div className="tool-label flex items-center gap-2 text-[#6b7280] ">
                <FaStar className="h-5 w-5 text-yellow-500" />
                <span className="mt-[4px]">Featured</span>
              </div>
              <Link
                rel="nofollow"
                target="_blank"
                className="hover:no-underline"
                to="#"
              >
                <button className=" border-2 border-customBlue flex text-white px-4 py-2 rounded hover:bg-background-primary transition text-[15px] font-bold uppercase">
                  <span className="mr-2">Visit</span>
                  <AiOutlineLink className="h-5 w-5" />
                </button>
              </Link>
            </div>
          </div>
        ))}
        </div>

        <div
        className="flex flex-col md:flex-row items-center  py-8 md:space-x-8 mt-16 pt-16 border-t-[1px] border-[#272727]"
        id="all-cate"
      >
        {/* Left Column: Title */}
        <div className="flex-1 flex flex-col items-center justify-center md:items-start mb-6 md:mb-0">
        <h2 className="text-[26px] md:text-[34px] text-center text-black leading-tight flex items-center" >
              <span className="font-bold text-[35px] md:text-[40px] bg-[linear-gradient(45deg,_#00bf67,_#0068ff)] bg-clip-text text-transparent mr-2">
              Image Editing
              </span>
              
            </h2>
        </div>

        {/* Right Column: Button */}
        <div className="flex-1 flex justify-center md:justify-end">
          <Link
            to="#"
            className="px-6 py-3 border-2 border-customBlue text-white font-semibold rounded shadow hover:bg-background-primary transition duration-200"
          >
            View More
          </Link>
        </div>
      </div>
      <div className="mx-auto grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3">
      {tools.map((tool, index) => (
          <div
            key={index}
            className="flex flex-col border-2 border-customGray hover:border-customBlue bg-background-back2 text-card-foreground h-full w-full rounded-xl"
          >
            <div className="px-6 pb-2 pt-4 flex h-24 items-start gap-4">
              <Link to={tool.link}>
                <div className="relative flex h-[60px] w-[60px] flex-shrink-0 rounded-xl border">
                  <img
                    alt={`${tool.name} logo`}
                    src={tool.logo}
                    className="aspect-square h-[60px] w-[60px] rounded-xl"
                  />
                </div>
              </Link>
              <div>
              <div>
                <h2 className="text-lg font-bold text-white">{tool.name}</h2>
                </div>
                {/* Rating stars */}
                    <div className=" flex items-center gap-1 text-yellow-500">
                    {Array.from({ length: 5 }, (_, i) => (
                        i < tool.rating ? (
                        <FaStar key={i} className="h-4 w-4 text-yellow-500" />
                        ) : (
                        <FaRegStar key={i} className="h-4 w-4 text-gray-300" />
                        )
                    ))}
                    <span className="text-gray-300 ml-2">({tool.rating})</span>
                </div>
              </div>
            </div>
            <div className="px-6">
              <div className="flex justify-between text-lg text-white">
                <span>Paid</span>
                  <Link to="" >
                  <span className="flex items-center text-slate-500">
                    <span className="mr-1">10</span>
                    <MdBookmark className="text-gray-300 hover:text-primary pointer h-5 w-5" />
                    <span className="sr-only">Add bookmark</span>
                  </span>
                  </Link>
              </div>
            </div>
            <p className="text-gray-300 my-2 line-clamp-2 overflow-hidden overflow-ellipsis px-6 text-base">
              Automate, schedule, and optimize brand-specific social content.
            </p>
            <div className="px-6 mb-6 flex flex-wrap gap-1 py-2 text-base text-ice-500">
              <div className="flex flex-wrap gap-x-2 gap-y-1 text-primary">
                <Link className="hover:text-underline" to="#">
                  #marketing
                </Link>
                <Link className="hover:text-underline" to="#">
                  #social media
                </Link>
                <Link className="hover:text-underline" to="#">
                  #copywriting
                </Link>
              </div>
            </div>

            <div className="px-6 mt-auto flex items-center justify-between pb-4">
              <div className="tool-label flex items-center gap-2 text-[#6b7280] ">
                <FaStar className="h-5 w-5 text-yellow-500" />
                <span className="mt-[4px]">Featured</span>
              </div>
              <Link
                rel="nofollow"
                target="_blank"
                className="hover:no-underline"
                to="#"
              >
                <button className=" border-2 border-customBlue flex text-white px-4 py-2 rounded hover:bg-background-primary transition text-[15px] font-bold uppercase">
                  <span className="mr-2">Visit</span>
                  <AiOutlineLink className="h-5 w-5" />
                </button>
              </Link>
            </div>
          </div>
        ))}
        </div>

        <div
        className="flex flex-col md:flex-row items-center  py-8 md:space-x-8 mt-16 pt-16 border-t-[1px] border-[#272727]"
        id="all-cate"
      >
        {/* Left Column: Title */}
        <div className="flex-1 flex flex-col items-center justify-center md:items-start mb-6 md:mb-0">
        <h2 className="text-[26px] md:text-[34px] text-center text-black leading-tight flex items-center" >
              <span className="font-bold text-[35px] md:text-[40px] bg-[linear-gradient(45deg,_#00bf67,_#0068ff)] bg-clip-text text-transparent mr-2">
              Text To Image
              </span>
              
            </h2>
        </div>

        {/* Right Column: Button */}
        <div className="flex-1 flex justify-center md:justify-end">
          <Link
            to="#"
            className="px-6 py-3 border-2 border-customBlue text-white font-semibold rounded shadow hover:bg-background-primary transition duration-200"
          >
            View More
          </Link>
        </div>
      </div>
      <div className="mx-auto grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3 mb-8">
      {tools.map((tool, index) => (
          <div
            key={index}
            className="flex flex-col border-2 border-customGray hover:border-customBlue bg-background-back2 text-card-foreground h-full w-full rounded-xl"
          >
            <div className="px-6 pb-2 pt-4 flex h-24 items-start gap-4">
              <Link to={tool.link}>
                <div className="relative flex h-[60px] w-[60px] flex-shrink-0 rounded-xl border">
                  <img
                    alt={`${tool.name} logo`}
                    src={tool.logo}
                    className="aspect-square h-[60px] w-[60px] rounded-xl"
                  />
                </div>
              </Link>
              <div>
              <div>
                <h2 className="text-lg font-bold text-white">{tool.name}</h2>
                </div>
                {/* Rating stars */}
                    <div className=" flex items-center gap-1 text-yellow-500">
                    {Array.from({ length: 5 }, (_, i) => (
                        i < tool.rating ? (
                        <FaStar key={i} className="h-4 w-4 text-yellow-500" />
                        ) : (
                        <FaRegStar key={i} className="h-4 w-4 text-gray-300" />
                        )
                    ))}
                    <span className="text-gray-300 ml-2">({tool.rating})</span>
                </div>
              </div>
            </div>
            <div className="px-6">
              <div className="flex justify-between text-lg text-white">
                <span>Paid</span>
                  <Link to="" >
                  <span className="flex items-center text-slate-500">
                    <span className="mr-1">10</span>
                    <MdBookmark className="text-gray-300 hover:text-primary pointer h-5 w-5" />
                    <span className="sr-only">Add bookmark</span>
                  </span>
                  </Link>
              </div>
            </div>
            <p className="text-gray-300 my-2 line-clamp-2 overflow-hidden overflow-ellipsis px-6 text-base">
              Automate, schedule, and optimize brand-specific social content.
            </p>
            <div className="px-6 mb-6 flex flex-wrap gap-1 py-2 text-base text-ice-500">
              <div className="flex flex-wrap gap-x-2 gap-y-1 text-primary">
                <Link className="hover:text-underline" to="#">
                  #marketing
                </Link>
                <Link className="hover:text-underline" to="#">
                  #social media
                </Link>
                <Link className="hover:text-underline" to="#">
                  #copywriting
                </Link>
              </div>
            </div>

            <div className="px-6 mt-auto flex items-center justify-between pb-4">
              <div className="tool-label flex items-center gap-2 text-[#6b7280] ">
                <FaStar className="h-5 w-5 text-yellow-500" />
                <span className="mt-[4px]">Featured</span>
              </div>
              <Link
                rel="nofollow"
                target="_blank"
                className="hover:no-underline"
                to="#"
              >
                <button className=" border-2 border-customBlue flex text-white px-4 py-2 rounded hover:bg-background-primary transition text-[15px] font-bold uppercase">
                  <span className="mr-2">Visit</span>
                  <AiOutlineLink className="h-5 w-5" />
                </button>
              </Link>
            </div>
          </div>
        ))}
        </div>
        </div>
      </div>
      <CallToAction />
      <Footer />
    </>
  );
};

export default AllImageCategories;
